module.exports = __webpack_public_path__ + "img/oeno-logo.011e1fa6.png";